<template>
<b-modal v-model="showFlg"
         size="lg"
         centered
         header-bg-variant="light"
         :modal-class="'setHeightCP001'"
         :hide-header="false"
         :hide-footer="false"
         :no-close-on-backdrop="false"
         @hide ="handleCancel"
         >
    <div class="cp001" v-cloak>
        <div class="container center">
                <!-- 新しいクーポンを -->
                <div><span class="cp001CoupponLabel1">{{$t("cp001.labels.couponlbl1")}}</span></div>
                <!-- 枚獲得しました -->
                <div><span class="cp001CoupponLabel2">{{newCouponCnt}}{{$t("cp001.labels.couponlbl2")}}</span>
                     <span class="cp001CoupponLabel3">{{$t("cp001.labels.couponlbl3")}}</span></div>
        </div>
    </div>
    <div slot="modal-footer">
            <div >
                <a href="javascript:void(0);"  v-on:click="gotoCoupponPage">
                    <!-- クーポン一覧へ >> -->
                    <b class="cp001CoupponLabel4">{{$t("cp001.labels.couponlbl4")}}</b><br> 
                </a>
            </div>
        </div>
</b-modal>
</template>

<script>
import axios from "assets/js/request";
import common from 'assets/js/common';
import PageFeed from "../commonParts/PageFeedTdk";
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import EventBus from "assets/js/eventBus";

export default {
    name: "tk020",
    components: {
        PageFeed,
        InputNumber,
        EventBus,
        Breadcrumb
    },
    props: {
        newCouponCnt: {
            type: [Number,String]
        }
    },
    data: function() {
        return {
            pageID: 'cp001',
            isDisplay: false,
            isPagingDisplay: false,
            reqModel: {

            },
            pt405Init: {
                pageNo: null,
                pageSize: null,
                tdkList: {}
            },
            queryData:null,
            pageFeedData: {
                totalRecord: 50,
                fromRecord: 1,
                toRecord: 10,
                pageSize: 10,
                pageNo: 1
            },

            SiteConstants: SiteConstants,
            showFlg: true,
            site: ""
        }
    },
    /*
    * Initialize
    */
    mounted: function() {
        //var _this = this;
        //axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.CP001 + _this.$UrlConstants.DO_INIT, _this.reqModel).then(function(response) {
        //    if(response.data.isLogin == true && response.data.newCouponCnt > 0 ){
        //        _this.showFlg = true;
        //        _this.newCouponCnt = response.data.newCouponCnt;
        //    } else {
        //        _this.showFlg = false;
        //        _this.newCouponCnt = 0;
         //   } 
        //}).catch(function(error) {
        //    common.errorAPI(error);
        //});
    },
    methods: {

        /**
         * delete favorite product
         * @param {String} tdkMSeq, tdk product
         */
        doDetail: function(tdkMSeq){
            var _this = this;
            var value = {};
            value.TDK_CD = tdkMSeq.TDK_CD;
            value.TDK_NO = tdkMSeq.TDK_NO;
            value.TDK_NM1 = tdkMSeq.TDK_NM1;
            value.TDK_NM2 = tdkMSeq.TDK_NM2;
            value.TDK_KANA1 = tdkMSeq.TDK_KANA1;
            value.TDK_KANA2 = tdkMSeq.TDK_KANA2;
            value.TDK_ZIP = tdkMSeq.TDK_ZIP;
            value.TDK_ADDR11 = tdkMSeq.TDK_ADDR11;
            value.TDK_ADDR2 = tdkMSeq.TDK_ADDR2;
            value.TDK_ADDR3 = tdkMSeq.TDK_ADDR3;
            value.TDK_TEL1 = tdkMSeq.TDK_TEL1;
            value.TDK_TEL2 = tdkMSeq.TDK_TEL2;
            this.$emit("data-selected", value);
            _this.showFlg = false;
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /**
         * get length a object
         * @param {Object} obj, object to get length
         */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
        //Methods for pageFeed
        changeSearch: function(sortNo, pageSize, pageNo) {
            this.pt405ReqModel.pageSize = pageSize;
            this.pt405ReqModel.pageNo = pageNo;
            this.pt405ReqModel.orderType = sortNo;

            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.CP001 + _this.$UrlConstants.DO_INIT, _this.pt405ReqModel).then(function(response) {
                if(response.data.isLogin == false){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
                }else{
                    _this.pt405Init = response.data;
                    _this.getDataForPageFeed(response.data);
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
            
        },
        /**
         * get page size, page no
         * @param {Number} val
         * @param {String} type
         */
        getQueryString: function(val, type){
            var query = this.$route.query;
            query.ptPageNo = this.pt405ReqModel.pageNo;
            query.ptPageSize = this.pt405ReqModel.pageSize;
            query[type] = val;

            var queryString = "";
            var index= 0;
            for(var propertyName in query) {
                if(index == 0){
                    queryString += propertyName + '=' + query[propertyName];
                } else{
                    queryString += '&' + propertyName + '=' + query[propertyName];
                }
                index++;
            }
            return queryString;
        },
        /**
         * get data for page feed
         * @param {Object} data, data from API
         */
        getDataForPageFeed: function(data){
            var _this = this;
            _this.pageFeedData.totalRecord = data.totalRecord;
            _this.pageFeedData.fromRecord = data.fromRecord;
            _this.pageFeedData.toRecord = data.toRecord;
            _this.pageFeedData.pageSize = data.pageSize;
            _this.pageFeedData.pageNo = data.pageNo;

            if(_this.pt405Init.tdkList.length > 0){
                _this.isPagingDisplay = true;
            }else{
                _this.isPagingDisplay = false;
            }
        },
        gotoCoupponPage: function(){
            var _this = this;
            _this.$router.push({name: _this.SiteConstants.PG010MAIN, query: {pageNo: 107, modeKbn:0}});
            _this.showFlg = false;
        },
        handleCancel(evt){
            evt.preventDefault();
            this.$emit("data-selected", null);
            this.showFlg = false;
        } 
    },

    /*
    * Excute code after an instance is created
    */
    created: function() {

    }
}
</script>
<style>

</style>